__turbopack_context__.v({
  "canadianBrand": "BuyCanadian-module-scss-module__tY8CFq__canadianBrand",
  "container": "BuyCanadian-module-scss-module__tY8CFq__container",
  "mapleLeafIcon": "BuyCanadian-module-scss-module__tY8CFq__mapleLeafIcon",
  "tooltip": "BuyCanadian-module-scss-module__tY8CFq__tooltip",
});
